<template>
  <div class="main-menu-wrap">
    <div :class="{ 'main-menu': true }">
      <router-link :to="'/'"
        ><img class="main-menu__logo" src="../assets/img/logo.svg"
      /></router-link>
      <ul
        :class="{
          'main-menu__menu': true,
          '--for-products': $route.path.indexOf('/products') !== -1,
          ['--current-repeat-slide-' + repeatSlideNum]: true,
        }"
      >
        <router-link
          v-for="(menuItem, index) in menuItems"
          :key="index"
          :class="{ '--active': checkActive(menuItem.url) }"
          :style="{ color: 'product-color(' + repeatSlideNum + ')' }"
          :to="'/' + menuItem.url"
        >
          <svg
            v-show="checkActive(menuItem.url)"
            class="_border-l"
            width="14"
            height="56"
            viewBox="0 0 14 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.23022 1.66547C10.3469 0.596611 11.8331 0 13.3789 0H14V56H13.3789C11.8331 56 10.3469 55.4034 9.23022 54.3345L1.85128 47.2719C0.668764 46.1401 0 44.5743 0 42.9374V13.0626C0 11.4257 0.668764 9.8599 1.85128 8.72808L9.23022 1.66547Z"
              fill="#00188A"
            />
          </svg>

          {{ menuItem.title }}
          <svg
            v-show="checkActive(menuItem.url)"
            class="_border-r"
            width="14"
            height="56"
            viewBox="0 0 14 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.76978 54.3345C3.65305 55.4034 2.16688 56 0.621068 56H0L0 0H0.621069C2.16688 0 3.65305 0.596611 4.76978 1.66547L12.1487 8.72808C13.3312 9.85991 14 11.4257 14 13.0626L14 42.9374C14 44.5743 13.3312 46.1401 12.1487 47.2719L4.76978 54.3345Z"
              fill="#00188A"
            />
          </svg>
        </router-link>
        <span class="--where" @click="showBuyOptions()">Где купить</span>
        <a
          href="https://contactus.mdlzapps.com/mondelezinternationalcom/contact/ru-RU/"
          target="_blank"
          >Обратная связь</a
        >
      </ul>

      <svg
        :class="{
          _burger: true,
          '--for-products': $route.path.indexOf('/products') !== -1,
        }"
        @click="showMobileMenu()"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="5" width="30" height="3" rx="1.5" fill="#00188A" />
        <rect y="14" width="30" height="3" rx="1.5" fill="#00188A" />
        <rect y="23" width="30" height="3" rx="1.5" fill="#00188A" />
      </svg>
    </div>
    <div v-if="showPopup" class="pop-up">
      <div class="pop-up__shade" @click="hidePopup()"></div>
      <WhereBuy :fullVersion="false" @close="hidePopup()" />
    </div>
    <MobileMenu
      v-if="isMobileMenuVisible"
      @buy-options="showBuyOptions()"
      @hide="isMobileMenuVisible = false"
    />
  </div>
</template>

<script>
import WhereBuy from "./WhereBuy.vue"
import MobileMenu from "./MobileMenu.vue"
export default {
  name: "MainMenu",
  components: {
    WhereBuy,
    MobileMenu,
  },
  data() {
    return {
      menuItems: [
        { url: "", title: "Главная" },
        { url: "products", title: "Продукция" },
      ],
      showPopup: false,
      isMobileMenuVisible: false,
    }
  },
  computed: {
    whiteMenu() {
      return this.$route.name == "products"
    },
    repeatSlideNum() {
      return this.$store.getters.getRepeatSlideNum()
    },
  },
  methods: {
    showMobileMenu() {
      this.isMobileMenuVisible = true
    },
    checkActive(url) {
      return (
        (url == "" && this.$route.path == "/") ||
        (url != "" && this.$route.path == "/" + url)
      )
    },
    showBuyOptions() {
      this.isMobileMenuVisible = false
      this.showPopup = true
    },
    hidePopup() {
      this.showPopup = false
    },
  },
}
</script>

<style lang="scss">
:root {
  --product-num: 1;
}
.main-menu-wrap {
  position: absolute;
  padding: 24px 0;
  left: 0;
  width: 100%;
  z-index: 100;
  @include respond-to("smartphone-plus") {
    padding: 6px 0;
  }
}
.main-menu {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 22px;
  ._burger {
    display: none;
  }
  @include respond-to("small") {
    margin: 0 40px;
  }
  @include respond-to("smartphone-plus") {
    display: block;
    margin: 0;
    .main-menu__logo {
      width: 64px;
      margin-left: 17px;
    }
    ._burger {
      display: block;
      position: absolute;
      top: 20px;
      right: 20px;
      &.--for-products {
        rect {
          fill: white;
        }
      }
    }
  }

  &__logo {
    width: 86px;
  }
  &__menu {
    display: flex;
    align-items: center;
    gap: 54px;
    font-family: $font-peach;
    font-size: 2.8rem;
    text-transform: uppercase;
    color: $color-blue;
    a {
      color: $color-blue;
      line-height: 1;
      display: flex;
      align-items: center;
      height: 56px;
      position: relative;
      padding: 0 6px;
    }
    .--where {
      cursor: pointer;
    }
    .--active {
      background-color: $color-blue;
      color: white;
      transform: rotate(-17deg);
      transition: color 0.1s ease-in;
      ._border-l,
      ._border-r {
        position: absolute;
        top: 0;
        path {
          fill: $color-blue;
        }
      }
      ._border-l {
        left: -13px;
      }
      ._border-r {
        right: -13px;
      }
    }
    &.--for-products {
      color: white;
      a {
        color: white;
      }
      .--active {
        background-color: white;
        color: $color-blue;
      }
      ._border-l,
      ._border-r {
        path {
          fill: white;
        }
      }
    }
    &.--for-products.--current-repeat-slide-1 .--active {
      color: product-color(1);
    }
    &.--for-products.--current-repeat-slide-2 .--active {
      color: product-color(2);
    }
    &.--for-products.--current-repeat-slide-3 .--active {
      color: product-color(3);
    }
    &.--for-products.--current-repeat-slide-4 .--active {
      color: product-color(4);
    }
    &.--for-products.--current-repeat-slide-5 .--active {
      color: product-color(5);
    }
    &.--for-products.--current-repeat-slide-6 .--active {
      color: product-color(6);
    }
    &.--for-products.--current-repeat-slide-7 .--active {
      color: product-color(1);
    }
    &.--for-products.--current-repeat-slide-8 .--active {
      color: product-color(2);
    }
    @include respond-to("smartphone-plus") {
      display: none;
    }
  }
}
.pop-up {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  &__shade {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
}
</style>
